import { render, staticRenderFns } from "./instruction.vue?vue&type=template&id=4c21fcce&scoped=true&"
import script from "./instruction.vue?vue&type=script&lang=js&"
export * from "./instruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c21fcce",
  null
  
)

export default component.exports